import React, {Component} from "react";
import config from 'react-global-configuration';

class GSTFilter extends Component {
    state = {
        gst_columns: 0,
    };
    componentDidMount(){

    }
    resetGSTFilter() {
        this.setState({
            gst_columns: 0,
        })
    }

    handleCheckGstCol(e){
        var gst_columns = 1;
        if (e.target.checked === true) {
            this.setState({gst_columns: 1})
        } else {
            this.setState({gst_columns: 0});
            gst_columns = 0;
        }
        this.props.onSelectGST(gst_columns);
    }
    render() {
        return (
         <label>
         <input type="checkbox" name="gst_columns"
           onChange={this.handleCheckGstCol.bind(this)}
           checked={(this.state.gst_columns == 1) ? true : false}/> &nbsp;  GST</label>
        );

    }
}
export default GSTFilter;